import React from 'react';
import { CONTACT_EMAIL, CONTACT_MAILTO } from '../../utils/contactInfo';
import styles from './ErrorBoundary.module.scss';

interface State {
  error: Error | null;
}

interface Props {
  children: React.ReactNode;
  fallback?: React.ReactNode;
}

export class ErrorBoundary extends React.Component<Props, State> {
  state: State = { error: null };

  static getDerivedStateFromError(error: Error): State {
    return { error };
  }

  componentDidCatch(error: Error, info: React.ErrorInfo) {
    // eslint-disable-next-line no-console
    console.error('[ErrorBoundary]', error, info.componentStack);
  }

  handleReset = () => {
    this.setState({ error: null });
    if (typeof window !== 'undefined') {
      window.location.assign('/');
    }
  };

  render() {
    if (this.state.error) {
      if (this.props.fallback) return <>{this.props.fallback}</>;
      return (
        <div className={styles.container} role="alert">
          <div className={styles.card}>
            <h1 className={styles.title}>Something went wrong</h1>
            <p className={styles.body}>
              The app hit an unexpected problem. You can return to the home screen and try again.
            </p>
            <button type="button" className={styles.button} onClick={this.handleReset}>
              Reload MyMinu
            </button>
            <p className={styles.contact}>
              If this keeps happening, write to{' '}
              <a href={CONTACT_MAILTO}>{CONTACT_EMAIL}</a>.
            </p>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}
